export default __webpack_public_path__ + "static/all3-4154dec8ee2a648cea01751f7a9db968.jpg";